import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { FaInstagram, FaLinkedin, FaXTwitter, FaEnvelope, FaBars, FaXmark, FaGithub } from 'react-icons/fa6';

const Navbar = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    // Close menu on escape key
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                setMobileMenuOpen(false);
            }
        };

        if (mobileMenuOpen) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden'; // Prevent scrolling when menu is open
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [mobileMenuOpen]);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
        setMobileMenuOpen(false); // Close menu after navigation
    };

    return (
        <>
            {/* Mobile Menu Overlay */}
            {mobileMenuOpen && (
                <div 
                    className="navbar-overlay" 
                    onClick={() => setMobileMenuOpen(false)}
                />
            )}
            
            <nav className="navbar">
                {/* Left: Name */}
                <div className="navbar-name">
                    <h1>Hamza Tariq</h1>
                </div>

            {/* Mobile Menu Toggle */}
            <button
                className="navbar-mobile-toggle"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                aria-label="Toggle menu"
            >
                {mobileMenuOpen ? <FaXmark /> : <FaBars />}
            </button>

            {/* Center: Navigation Links */}
            <div className={`navbar-links ${mobileMenuOpen ? 'active' : ''}`}>
                <button onClick={() => scrollToSection('home')}>Home</button>
                <button onClick={() => scrollToSection('skills')}>Skills</button>
                <button onClick={() => scrollToSection('experiences')}>Experiences</button>
                <button onClick={() => scrollToSection('projects')}>Projects</button>
                <button onClick={() => scrollToSection('certifications')}>Certifications</button>
                <button onClick={() => scrollToSection('gallery')}>Gallery</button>
                
                {/* Social Icons in Mobile Menu */}
                <div className="navbar-mobile-socials">
                    <a href="https://www.instagram.com/hamzzatariq?igsh=MXR6bDA3YzJrd2Z3aQ==" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                        <FaInstagram />
                    </a>
                    <a href="https://www.linkedin.com/in/hamza-tariq-60a170225" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                        <FaLinkedin />
                    </a>
                    <a href="https://github.com/Hamzatariq211" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                        <FaGithub />
                    </a>
                    <a href="https://x.com/hamza_tariq_?s=21" target="_blank" rel="noopener noreferrer" aria-label="X">
                        <FaXTwitter />
                    </a>
                    <a href="mailto:hamzatariq20@outlook.com" aria-label="Email">
                        <FaEnvelope />
                    </a>
                </div>
            </div>

            {/* Right: Social Icons - Desktop Only */}
            <div className="navbar-socials">
                <a href="https://www.instagram.com/hamzzatariq?igsh=MXR6bDA3YzJrd2Z3aQ==" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <FaInstagram />
                </a>
                <a href="https://www.linkedin.com/in/hamza-tariq-60a170225" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <FaLinkedin />
                </a>
                <a href="https://github.com/Hamzatariq211" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                    <FaGithub />
                </a>
                <a href="https://x.com/hamza_tariq_?s=21" target="_blank" rel="noopener noreferrer" aria-label="X">
                    <FaXTwitter />
                </a>
                <a href="mailto:hamzatariq20@outlook.com" aria-label="Email">
                    <FaEnvelope />
                </a>
            </div>
        </nav>
        </>
    );
};

export default Navbar;
